<template>
    <div class="main">
        <div class="role_left">
            <!-- <p class="role_p">
                <el-button round @click="openDialog">创建角色</el-button>
            </p>
            <p class="role_p"><span>角色列表</span></p> -->

            <div id="hello-hello">
                <p style="display:inline;float: left;line-height: 22px;"><b>角色列表</b></p>
                <p style="display:inline;float: right;line-height: 22px;margin: 5px 0;">
                    <el-button round type="success" @click="openDialog">创建角色</el-button>
                </p>
            </div>

            <el-table :data="roleList" style="width: 100%">
                <el-table-column prop="roleName" label="角色名称" min-width="50%">
                </el-table-column>
                <el-table-column prop="roleDescription" label="角色描述" min-width="50%">
                </el-table-column>

                <el-table-column fixed="right" label="操作" width="330">
                    <template slot="header">
                        <el-tooltip class="item" effect="light" placement="top" content="系统管理员不允许编辑和删除">
                            <span>操作</span>
                        </el-tooltip>
                    </template>

                    <template slot-scope="scope">
                        <el-button @click="handleClick(scope.row)" type="primary" round size="small"
                            v-if="scope.row.allowEdit != 0">
                            {{ scope.row.allowEdit == 0 ? '' : '编辑' }}
                        </el-button>

                        <el-button @click="bindClick(scope.row)" type="primary" round size="small">
                            绑定员工
                        </el-button>

                        <el-button @click="deleteClick(scope.row)" type="warning" round size="small"
                            v-if="scope.row.allowEdit != 0">
                            {{ scope.row.allowEdit == 0 ? '' : '删除' }}
                        </el-button>

                        <el-button @click="checkClick(scope.row)" type="primary" round size="small">
                            查看权限
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-dialog title="角色编辑" :visible.sync="dialogFormVisible" width="40%">
                <el-form :model="form">
                    <el-form-item label="角色名称" required :label-width="formLabelWidth">
                        <el-input v-model="form.roleName" autocomplete="off"></el-input>
                    </el-form-item>

                    <el-form-item label="角色描述" required :label-width="formLabelWidth">
                        <el-input v-model="form.roleDescription" autocomplete="off" type="textarea"></el-input>
                    </el-form-item>
                </el-form>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addRole">保 存</el-button>
                </div>
            </el-dialog>

            <el-dialog title="员工绑定" :visible.sync="dialogTableVisible">
                <el-table :data="empList">
                    <el-table-column property="employeeName" label="姓名" width="160"></el-table-column>
                    <el-table-column property="phone" label="智模号" width="150"></el-table-column>
                    <el-table-column property="roleDescription" label="角色" width="270"></el-table-column>

                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button @click="bindOrNoClick(scope.row)" type="text" size="small"
                                style="color:#6f5499">{{
                        scope.row.userRoleId == null ? '绑定' : '取消绑定'
                    }}</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 分页 -->
                <div>
                    <el-pagination background :page-size="pageNum" layout="prev, pager, next" :total="total"
                        @current-change="pageClick" hide-on-single-page>
                    </el-pagination>
                </div>
            </el-dialog>
        </div>

        <div class="role_right">

            <div id="hello-hello">
                <p style="display:inline;float: left;line-height: 22px;">
                    <b>【{{ showRoleDescription }}】<span style="color:#6f5499">拥有的权限</span></b>
                </p>
                <p style="display:inline;float: right;line-height: 22px;margin: 5px 0;">
                    <el-button round type="warning" @click="savePermission">保存</el-button>
                </p>
            </div>

            <div style="overflow:auto;height: 550px;">
                <el-tree :data="permissionTree" show-checkbox node-key="id" default-expand-all
                    :expand-on-click-node="false" :default-checked-keys="checkedIds" :check-strictly=true
                    @check-change="checkChange" ref="tree">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span @click="() => editClick(node, data)">
                            <i :class="data.icon"></i>&nbsp;
                            
                            <el-tag size="mini" :type="data.type == '模块' ? '' : data.type == '菜单' ? 'warning' : 'info'">
                                {{ data.type }}</el-tag>&nbsp;
                            <span>{{ node.label }}</span>
                        </span>
                    </span>
                </el-tree>
            </div>
        </div>
    </div>
</template>

<script>
import globalMethod from "@/method/globalMethod.js";

export default {
    name: "Role",
    mixins: [globalMethod],
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            roleList: [],
            dialogFormVisible: false,
            form: {
                roleId: '',
                roleName: '',
                roleDescription: ''
            },
            formLabelWidth: '100px',
            dialogTableVisible: false,
            empList: [],
            checkedIds: [],
            currentCheckedKeys: [],
            showRoleDescription: '',
            permissionTree: [{
                id: '1',
                label: '看板管理',
                type: '模块',
                icon: 'el-icon-document',
                children: [{
                    id: '10',
                    label: 'CNC看板',
                    type: '菜单',
                    icon: '',
                    children: []
                }, {
                    id: '11',
                    label: '生产看板',
                    type: '菜单',
                    icon: '',
                    children: []
                }]
            }, {
                id: '2',
                label: '订单管理',
                type: '模块',
                icon: 'el-icon-document',
                children: [{
                    id: '20',
                    label: '模具订单',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '200',
                        label: '查询',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '201',
                        label: '新增',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '202',
                        label: '更改',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '203',
                        label: '删除',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }, {
                    id: '21',
                    label: '模具BOM',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '210',
                        label: '查询',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '211',
                        label: '新增',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '212',
                        label: '更改',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '213',
                        label: '删除',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '214',
                        label: '批量导入',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }, {
                    id: '22',
                    label: '制定工艺',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '220',
                        label: '查询',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '221',
                        label: '新增',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }]
            }, {
                id: '3',
                label: '生产管理',
                type: '模块',
                icon: 'el-icon-document',
                children: [{
                    id: '30',
                    label: '工艺流程',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '300',
                        label: '查询',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }, {
                    id: '31',
                    label: '装配',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '310',
                        label: '查询',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '311',
                        label: '更改',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }, {
                    id: '32',
                    label: '抛光',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '320',
                        label: '查询',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '321',
                        label: '新增',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }, {
                    id: '33',
                    label: '试模',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '330',
                        label: '查询',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '331',
                        label: '新增',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }, {
                    id: '34',
                    label: '维修',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '340',
                        label: '查询',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '341',
                        label: '新增',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }]
            }, {
                id: '4',
                label: '模具管理',
                type: '模块',
                icon: 'el-icon-document',
                children: [{
                    id: '40',
                    label: '仓储管理',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '400',
                        label: '查询',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '401',
                        label: '新增',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '402',
                        label: '接收',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }]
            }, {
                id: '5',
                label: '工厂管理',
                type: '模块',
                icon: 'el-icon-document',
                children: [{
                    id: '50',
                    label: '公司信息',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '500',
                        label: '编辑',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '501',
                        label: '注销',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }, {
                    id: '51',
                    label: '班次时间',
                    type: '菜单',
                    icon: '',
                    children: []
                }, {
                    id: '52',
                    label: '部门管理',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '520',
                        label: '新增',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '521',
                        label: '编辑',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '522',
                        label: '绑定角色',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '523',
                        label: '删除',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }, {
                    id: '53',
                    label: '员工管理',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '530',
                        label: '新增',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '531',
                        label: '删除',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }, {
                    id: '54',
                    label: '角色&权限',
                    type: '菜单',
                    icon: '',
                    children: [{
                        id: '540',
                        label: '新增',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '541',
                        label: '编辑',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '542',
                        label: '绑定员工',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '543',
                        label: '删除',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '544',
                        label: '查看权限',
                        type: '功能',
                        icon: '',
                        children: []
                    }, {
                        id: '545',
                        label: '保存',
                        type: '功能',
                        icon: '',
                        children: []
                    }]
                }]
            }, {
                id: '6',
                label: '基础资料',
                type: '模块',
                icon: 'el-icon-document',
                children: [{
                    id: '60',
                    label: 'BOM资料',
                    type: '菜单',
                    icon: '',
                    children: []
                }, {
                    id: '61',
                    label: '客户资料',
                    type: '菜单',
                    icon: '',
                    children: []
                }]
            }, {
                id: '7',
                label: '设备管理',
                type: '模块',
                icon: 'el-icon-document',
                children: [{
                    id: '70',
                    label: 'CNC设备',
                    type: '菜单',
                    icon: '',
                    children: []
                }, {
                    id: '71',
                    label: 'CNC操录',
                    type: '菜单',
                    icon: '',
                    children: []
                }]
            }],
            tagType: 'warning',
            pageIndex: 0,
            pageNum: 5,

            total: 0
        }
    },
    methods: {
        openDialog() {
            
            this.form.roleId = ''
            this.form.roleName = ''
            this.form.roleDescription = ''
            this.dialogFormVisible = true
        },
        handleClick(row) {
            
            this.form.roleId = row.roleId
            this.dialogFormVisible = true
            this.form.roleName = row.roleName
            this.form.roleDescription = row.roleDescription
        },
        addRole() {
            this.$axios({
                method: "post",
                url: "/shiro/role/add",
                data: {
                    roleId: this.form.roleId,
                    roleName: this.form.roleName,
                    roleDescription: this.form.roleDescription,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                this.dialogFormVisible = false

                this.getRoles()

                this.$message({
                    type: 'success',
                    message: result.data.msg
                })
            })
        },
        getRoles() {
            this.$axios({
                method: "post",
                url: "/shiro/role/getAll",
                data: {
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                this.roleList = data.data
                this.showRoleDescription = this.roleList[0].roleDescription
                this.checkedIds = this.getPermissionIds(this.roleList[0].roleId)
                this.form.roleId = this.roleList[0].roleId
            })
        },
        bindClick(row) {

            this.form.roleId = row.roleId
            this.dialogTableVisible = true

            this.empList = this.getEmpsByRoleId({
                roleId: row.roleId,
                companyId: this.companyId,
                pageIndex: this.pageIndex,
                pageNum: this.pageNum
            }, this.token)

            this.total = this.empList[0].total
        },
        bindOrNoClick(row) {
            if (row.userRoleId == null) {
                this.bindEmp(row)
            } else {
                this.unBindEmp(row)
            }
        },
        bindEmp(row) {
            this.$axios({
                method: "post",
                url: "/shiro/employee/bind",
                data: {
                    userId: row.userId,
                    roleId: this.form.roleId,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                this.$message({
                    type: 'success',
                    message: result.data.msg
                })

                this.empList = this.getEmpsByRoleId({
                    roleId: this.form.roleId,
                    companyId: this.companyId,
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum
                }, this.token)

                this.total = this.empList[0].total
            })
        },
        unBindEmp(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/employee/unBind",
                data: {
                    userRoleId: row.userRoleId,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                this.$message({
                    type: 'success',
                    message: result.data.msg
                })

                this.empList = this.getEmpsByRoleId({
                    roleId: this.form.roleId,
                    companyId: this.companyId,
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum
                }, this.token)

                this.total = this.empList[0].total
            })
        },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.removeRole(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        removeRole(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/role/remove",
                data: {
                    roleId: row.roleId,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                this.$message({
                    message: result.data.msg
                })

                this.getRoles()
            })
        },
        checkClick(row) {

            this.showRoleDescription = row.roleDescription

            this.getPermissionIds(row.roleId)

            this.form.id = row.id
            this.form.roleId = row.roleId
        },
        // getPermissionTree() {
        //     this.$axios({
        //         method: "get",
        //         url: "/shiro/role/permission/getTree",
        //         data: {},
        //         headers: {
        //             token: this.token
        //         }
        //     }).then(result => {

        //         this.permissionTree = result.data.data
        //     })
        // },
        getPermissionIds(roleId) {
            this.$axios({
                method: "post",
                url: "/shiro/role/permission/get",
                data: {
                    roleId: roleId,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message({
                        message: data.msg
                    })
                }

                this.checkedIds = data.data

                this.$refs.tree.setCheckedKeys(this.checkedIds)

            })
        },
        checkChange() {

            let preCheckedKeys = this.currentCheckedKeys

            this.currentCheckedKeys = this.$refs.tree.getCheckedKeys()

            if (preCheckedKeys.length > this.currentCheckedKeys.length) {
                for (let i in preCheckedKeys) {
                    for (let j in this.currentCheckedKeys) {
                        
                        if (preCheckedKeys[i] === this.currentCheckedKeys[j]) {

                            
                            preCheckedKeys.splice(i, 1)
                        }
                    }
                }
            }

            let node = this.$refs.tree.getNode(preCheckedKeys[0])
            if (node != null && node.checked === false && node.isLeaf === false) {

                const arr = []
                node.childNodes.forEach(element => {
                    arr.push(element.data.id);
                    if (element.childNodes.length != 0) {
                        element.childNodes.forEach(el => {
                            arr.push(el.data.id);
                        });
                    }
                })

                for (let i in arr) {
                    this.$refs.tree.getNode(arr[i]).checked = false
                }
            }

        },
        savePermission() {

            let permissionIds = this.$refs.tree.getCheckedKeys()

            this.$axios({
                method: "post",
                url: "/shiro/role/permission/modify",
                data: {
                    roleId: this.form.roleId,
                    permissionIdSet: permissionIds,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                if (result.data.status === 200) {
                    this.$message({
                        type: 'success',
                        message: result.data.msg
                    })
                } else {
                    this.$message({
                        type: 'info',
                        message: result.data.msg
                    })
                }
            })
        },
        pageClick(currentPage) {
            
            this.pageIndex = (currentPage - 1) * this.pageNum

            this.empList = this.getEmpsByRoleId({
                roleId: this.form.roleId,
                companyId: this.companyId,
                pageIndex: this.pageIndex,
                pageNum: this.pageNum
            }, this.token)

            this.total = this.empList[0].total
        }
    },
    mounted() {
        //console.log('mounted')
        this.getRoles()

        // this.getPermissionTree()
    }
}
</script>

<style>
.role_left {
    width: 68%;
    height: 550px;
    display: inline;
    float: left;
}

.role_right {
    width: 30%;
    height: 620px;
    display: inline;
    float: right;
}

.role_p {
    position: relative;
    right: 5px;
    width: 120px;
    margin: 10px 0px 30px 0px;
}

.role_span {
    border: 1px solid #6f5499;
    border-radius: 5px;
    margin: 0px 10px;
    font-size: 12px;
    color: #6f5499;
}
</style>